module.exports = __webpack_public_path__ + "static/media/Mellat.046d56d9.svg";